<template>
    <div class="main">
        <div class="x-subnav">
      <xy-toolbox-menu class="l" :items="equipMenu" current="车款对比"  />
      <xy-toolbox-menu class="r"  >
        <xy-toolbox-menu-item icon="car_search" @click="gocompare">添加车款</xy-toolbox-menu-item>
        <xy-toolbox-menu-item icon="excel" @click="exportExcel">Excel导出</xy-toolbox-menu-item>
      </xy-toolbox-menu>
    </div>
 
        <el-table :data="modeData" border height="650" style="width: 98%; margin:20px 10px 10px 10px;" v-show="false">
            <el-table-column prop="tag" label="大类" align="center" width="180"> </el-table-column>
            <el-table-column prop="name" label="装备名称"></el-table-column>
            <el-table-column prop="val" label="装备选项组"></el-table-column>
            <el-table-column align="center" label="装车率">
                <el-table-column icon="el-icon-search" align="center" :prop="n.name" :key="n.name" :label="n.name" v-for='n in queryParams'>
                </el-table-column>
            </el-table-column>
        </el-table>
        <div class="pk1box">
            <h3> </h3>
            <div v-html="content"></div>
            <h3> </h3>
        </div>
    </div>
</template>
<script>
    const OptionPattern = /\(选装:(.*?)\)/g;
    import {
        mapMutations,
        mapGetters,
        mapActions
    } from "vuex";
    import SearchBar from "@/components/common/EquipSearch.vue";
    import {
        formatDate,
        strToFormatDate
    } from "@/plugins/DateTimeFormater.js";
    export default {
        name: "equippk4",
        data() {
            return {
                tableCfg: null,
                pkids: [],
                queryParams: [],
                modeData: [],
                content: 'loading...',
            }
        },
        methods: {
            ...mapActions("equipanalysis", ["queryEquipParamsByModel"]),
            test() {},
            gocompare() {
                this.$router.push({
                    name: 'equipmodelcompare'
                });
            },
            exportExcel(){
                this.modeData = [];

                
                     var msrp = {
                          '大类': 'MSRP',
                        '装备名称': 'MSRP',
                        '装备选项组': 'MSRP',
                       
                    };
                     for (var z of this.equipParamsByModel.models) {
                               msrp[z.name] ='' + this.formatw(z.minMsrp) + ' ~ ' + this.formatw(z.maxMsrp) + '' ;
                       }
 
                    this.modeData.push(msrp);
              

                this.equipParamsByModel.list.forEach(x => {
                     var r = {
                            '大类': x.tag,
                        '装备名称': x.name,
                        '装备选项组': x.val,
                     
                    };
                    for (var z of x.modes) {
                        r[z.name] =' '+ z.used + ' / ' + z.lines+' ';
                    }
                    this.modeData.push(r);
                });
             JSONToExcel(this.modeData, "PK", "equip");
            },
            formatw(v)
            {

                return (v/10000).toFixed(2);
            },
            bindData() {
           
                var list = [];
                var categories = new Set(this.equipParamsByModel.list.map(x => {
                    return x.tag;
                }));
                for (var key of categories) {
                    this.equipParamsByModel.list.forEach(j => {
                        if (j.tag == key) {
                            list.push(j);
                        }
                    });
                }
                ///   alert(JSON.stringify(this.modeData));
                
                var arrlen =  this.equipParamsByModel.models.length  ;
            
                var html = '<div class="pk-content pk4" style="grid-template-columns: auto 220px 220px ' + " auto".repeat(arrlen) + ';">';
                html += ' <div class="item car-label gy">分类</div>';
                html += ' <div class="item car-label gy">名称</div>';
                html += ' <div class="item car-label gy">值</div> ';
                for (var z of list[0].modes) {
                    html += ' <div class="item car-name gy">' + z.name + '    </div>';
                }

             html += ' <div class="item car-label gy">MSRP</div>';
                html += ' <div class="item car-label gy">MSRP</div>';
                html += ' <div class="item car-label gy">MSRP</div>';
                for (var z of this.equipParamsByModel.models) {
                    html += ' <div class="item car-name gy">' + this.formatw(z.minMsrp) + ' ~ ' + this.formatw(z.maxMsrp) + '     </div>';
                }



                for (var item of list) {
                    html += ' <div class="item v">' + item.tag + '</div>';
                    html += ' <div class="item v">' + item.name + '</div>';
                    if (item.name == item.val) {
                        html += ' <div class="item v"> </div>';
                    } else {
                        html += ' <div class="item v">' + item.val + '</div>';
                    }
                    for (var z of item.modes) {
                        if ((z.used * 2) > z.lines) {
                            html += ' <div class="item v k">' + z.used + '/ ' + z.lines + '</div>';
                        } else {
                            html += ' <div class="item v">' + z.used + '/ ' + z.lines + '</div>';
                        }
                    }
                }
                html += '</html>';
                this.content = html;
            },
            queryData() {
                var postData = {
                    ids: this.pkids
                };
                this.queryEquipParamsByModel({
                    params: postData
                });
            },
            objectSpanMethod({
                row,
                column,
                rowIndex,
                columnIndex
            }) {
                var cfg = this.tableCfg.get(row.tag);
                if (columnIndex === 0) {
                    let count = cfg.endIndex - cfg.startIndex + 1;
                    if (rowIndex === cfg.startIndex) {
                        return {
                            rowspan: count,
                            colspan: 1
                        };
                    } else if (rowIndex > cfg.startIndex && rowIndex <= cfg.endIndex) {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            },
        },
        computed: {
            ...mapGetters("equipanalysis", {
                equipParamsByModel: "equipParamsByModel"
            })
        },
        watch: {
            equipParamsByModel(value) {
                this.bindData();
            }
        },
        mounted() {
            var params = this.$route.params.q;
            if (params == undefined) {
                return;
            }
            // alert(JSON.stringify(params));
            this.queryParams = params;
            var ids = new Set();
            params.forEach(x => {
                ids.add(x.modeId);
            });
            this.pkids = [...ids];
            this.queryData();
        }
    }
</script>

